The earliest event to replay.
